import React from "react";
import { Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const CustomButton = ({ButtonName, handleSubmit}) => {
  return (
    <>
      <Button
        sx={{
          mt: 3,
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          fontFamily: "Inria Sans, sans-serif",
          fontSize: "15px",
          fontWeight: 600,
          lineHeight: "1.1em",
          textAlign: "start",
          padding: "10px 24px 10px 20px",
          border: "2px solid #065A79",
          borderRadius: "100px",
          color: "#065A79",
          backgroundColor: "#fff",
          overflow: "hidden",
          zIndex: 1,
          transition: "color 0.5s ease",

          // Background slide effect
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: 0,
            backgroundColor: "#AD1C86",
            zIndex: 0,
            transition: "width 0.6s ease",
          },

          "&:hover::before": {
            width: "100%",
          },

          "&:hover": {
            color: "#fff",
          },

          "& span, & .arrow-icon": {
            position: "relative",
            zIndex: 1,
          },

          "& .arrow-icon": {
            backgroundColor: "#AD1C86",
            color: "#fff",
            border: "2px solid #065A79",
            borderRadius: "50%",
            padding: "2px",
            width: "33px",
            height: "33px",
            marginLeft: "8px",
            transition: "all 0.5s ease",
          },

          "&:hover .arrow-icon": {
            marginLeft: "20px",
            backgroundColor: "#fff",
            color: "#AD1C86",
            borderColor: "#AD1C86",
          },
        }}
        onClick={handleSubmit}
      >
        <span>{ButtonName}</span>
        <ArrowForwardIcon className="arrow-icon" />
      </Button>
    </>
  );
};

export default CustomButton;
